"use client";

import { usePathname } from "next/navigation";
import { Home, MapPin, Ticket, CalendarPlus, User } from "lucide-react";

const TABS = [
  { label: "Home", href: "/", icon: Home, exact: true },
  { label: "Trips", href: "/trips", icon: Ticket },
  { label: "Book", href: "/book", icon: CalendarPlus },
  { label: "Track", href: "/track", icon: MapPin },
  { label: "Profile", href: "/profile", icon: User },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 flex items-center justify-around border-t z-50"
      style={{
        backgroundColor: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        paddingBottom: "env(safe-area-inset-bottom)",
        height: 72,
      }}
    >
      {TABS.map((tab) => {
        const active = "exact" in tab ? pathname === tab.href : (pathname === tab.href || pathname.startsWith(tab.href + "/"));
        return (
          <a
            key={tab.label}
            href={tab.href}
            className="flex flex-col items-center gap-0.5 py-2 px-4 rounded-lg transition-colors"
            style={{ color: active ? "var(--primary)" : "var(--text-muted)" }}
          >
            <tab.icon className="w-5 h-5" strokeWidth={active ? 2.2 : 1.8} />
            <span className="text-[10px] font-medium" style={{ fontWeight: active ? 600 : 400 }}>{tab.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
